import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { IGNORE_META_ERROR_MESSAGE } from '@sb/shared/util';
import { map } from 'rxjs';

import type { ContractRenewal, ContractRenewalsList, ContractRenewalsMeta } from './contract-renewals.models';

@Injectable({ providedIn: 'root' })
export class ContractRenewalsApiService {
  #gateway = inject(ApiGateway);

  list() {
    return this.#gateway
      .get<{ data: ContractRenewal[]; meta: ContractRenewalsMeta }>('hiring/contract-renewals', {
        meta: true,
        context: new HttpContext().set(IGNORE_META_ERROR_MESSAGE, true),
      })
      .pipe(
        map(({ data, meta }): ContractRenewalsList => ({
          rows: data,
          scopeLocationIds: meta.scope_location_ids,
        })),
      );
  }
}
